import { render, staticRenderFns } from "./PhotofixrGrid.vue?vue&type=template&id=e4ee36c4&"
import script from "./PhotofixrGrid.vue?vue&type=script&lang=js&"
export * from "./PhotofixrGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports